export function getAnalyticsDebug(): boolean {
    const isDevEnv =
        ["development", "preview"].includes(process.env.NEXT_PUBLIC_VERCEL_ENV ?? "") ||
        process.env.NODE_ENV === "development";

    if (typeof document === "undefined") {
        return isDevEnv;
    }

    const hasOptOut = document.cookie.includes("analytics-opt-out");

    return hasOptOut || isDevEnv;
}
